var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('header-docs', {
    staticClass: "freeze",
    attrs: {
      "active": _vm.type
    }
  }), _vm._v(" "), (_vm.type === 'base') ? _c('n3-container', {
    staticClass: "bs-docs-container"
  }, [_c('n3-row', [_c('n3-column', {
    attrs: {
      "col": 2
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "searchCom",
    attrs: {
      "placeholder": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('n3-nav', {
    attrs: {
      "type": "vertical",
      "default-openeds": ['Base', 'Tooltip', 'Form', 'Display', 'Navigation', 'Others']
    },
    on: {
      "select": _vm.select
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('n3-sub-nav', {
      key: index,
      attrs: {
        "index": index
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _vm._l((item.list), function(i, index1) {
      return _c('n3-nav-item', {
        key: index1,
        attrs: {
          "index": index1,
          "active": _vm.component == i.value
        },
        nativeOn: {
          "click": function($event) {
            _vm.change(i.value)
          }
        }
      }, [_c('a', {
        domProps: {
          "textContent": _vm._s(i.label)
        }
      })])
    })], 2)
  }))], 1), _vm._v(" "), _c('n3-column', {
    attrs: {
      "col": 10
    }
  }, [_c(_vm.component, {
    tag: "component"
  })], 1)], 1)], 1) : [_vm._t("default")]], 2), _vm._v(" "), _c('footer', {
    staticClass: "bs-docs-footer"
  }, [_c('n3-container', [_c('ul', [_c('li', [_c('span', [_vm._v("Email:")]), _vm._v("zhangking520@gmail.com")]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Github:")]), _c('a', {
    attrs: {
      "href": "https://github.com/N3-components/N3-components"
    }
  }, [_vm._v("Repository")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("QQ Group:")]), _vm._v("556286036")]), _vm._v(" "), _c('li', [_c('span', [_vm._v("gitter:")]), _c('a', {
    attrs: {
      "href": "https://gitter.im/N3-components/english?utm_source=share-link&utm_medium=link&utm_campaign=share-link"
    }
  }, [_vm._v("gitter link ")])])])])], 1)])
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-44c6f6c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44c6f6c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example_en/n3Docs.vue
// module id = 888
// module chunks = 1